<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content class="signature-content">
  <div class="signature-handler-container">
    <lfe-signature-canvas #signatureCanvas (hasDrawnChange)="onCanvasDrawn($event)"></lfe-signature-canvas>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    {{ translateService.instant('liveforms-editor.common.buttons.cancel') }}
  </button>
  <button mat-raised-button color="primary" [disabled]="!hasDrawn()" (click)="save()">
    {{ translateService.instant('liveforms-editor.common.buttons.save') }}
  </button>
</mat-dialog-actions>
